import { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Collapse,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import PersonalInjuryOutlinedIcon from '@mui/icons-material/PersonalInjuryOutlined';
import VaccinesIcon from '@mui/icons-material/Vaccines';

import axios from 'axios';
import Carousel from 'react-bootstrap/Carousel';
import { Link as RouterLink } from 'react-router';

import MainBar from '../components/mainbar';
import { ResultCard, ResultType } from '../components/results';
import ShareLinks from '../components/ShareLinks';
import { BigSearch } from '../components/search_bar';
import { useAuth } from '../utils/AuthContext';
import { useJiang } from '../utils/JiangContext';

import 'bootstrap/dist/css/bootstrap.min.css';

const Home = () => {
  const { api, status } = useAuth();
  const { bigger_than_xs, bigger_than_md } = useJiang();
  const theme = useTheme();

  const [images, setImages] = useState<string[]>(['/news/carousel1.jpg']);
  const [newest, setNewest] = useState<ResultType[]>([]);
  useEffect(() => {
    const fetch_data = async () => {
      const res = await api.get('/api/newest');
      // console.log('res newest', res.data);
      setNewest(res.data);
    }
    fetch_data();
  }, []);
  const [showMore, setShowMore] = useState<boolean>(false);

  const yellow_color = theme.palette.secondary.main;
  const red_color = theme.palette.error.main;

  const carousel_base_link = process.env.REACT_APP_CAROUSEL_LINK ?? '/news'
  const become_member_link = process.env.REACT_APP_BECOME_MEMBER_LINK ?? ''
  const idf_link = process.env.REACT_APP_IDF_LINK ?? ''
  const line_link = process.env.REACT_APP_LINE_LINK ?? ''
  const yt_link = process.env.REACT_APP_YT_LINK ?? ''

  const become_member_btn = (
    <Button
      variant='contained'
      sx={{ width: 170 }}
      to={become_member_link}
      component={RouterLink}
      target='_blank'
    >
      <Typography variant='body1'>醫療人員申請會員</Typography>
    </Button>
  )

  useEffect(() => {
    const fetch_carousel = async () => {
      try {
        const res = await axios.get(`${carousel_base_link}/manifest.json`);
        const manifest = res.data;
        // console.log('manifest', manifest);
        if (manifest.length > 0) {
          const new_images = manifest.map((s: string) => `${carousel_base_link}/${s}`)
          // console.log('new_images', new_images);
          setImages(new_images);
        }
      } catch (e) { console.log('Cannot find manifest.json') }
    }
    fetch_carousel();
  }, []);

  return (
    <>
      <MainBar />
      {/* Carousel */}
      <Box sx={{ mb: 2 }} style={{ background: 'linear-gradient(160deg, #eaf7dc 0%, #f9f2ff 100%)' }}>
        <Container maxWidth='lg' sx={{ px: { xs: 0, md: 3 }, }}>
          <Carousel>
            {
              images.map((src: string) =>
                <Carousel.Item key={src}>
                  <Box
                    sx={{
                      aspectRatio: '16 / 7',
                      width: '100%',
                      overflow: 'hidden', bgcolor: 'white', cursor: 'pointer'
                    }}
                  >
                    <Box
                      component='img'
                      src={src}
                      sx={{
                        width: '100%',
                        height: '100%',
                        // objectFit: 'cover',
                        objectFit: 'scale-down',
                      }} />
                  </Box>
                </Carousel.Item>
              )
            }
          </Carousel>
          {
            status !== 'logged_in' && bigger_than_md &&
            <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4, pb: 4 }}>
              {become_member_btn}
            </Box>
          }
        </Container>
      </Box>
      {/* Search and New Videos */}
      <Container sx={{ mb: 4 }}>
        <BigSearch />
        <div style={{ marginTop: bigger_than_xs ? 50 : 30 }} />
        {/* Below could be a temporary solution */}
        <Grid container justifyContent='start' alignContent='center' sx={{ height: '30px' }} id='newest'>
          <Grid size={{ xs: 4 }} sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h4' color='primary.light' sx={{ fontWeight: 'bold' }}>新影片</Typography>
          </Grid>
          <Grid size={{ xs: 2 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} offset={1}>
            <ShareLinks results={newest} />
          </Grid>
        </Grid>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <ShareLinks results={newest} />
        </Box> */}
        <Grid container spacing={{ xs: 0, sm: 2 }} sx={{ mt: 4 }}>
          {
            newest.map((item: any, index: number) => (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }} sx={{ transition: 'all 0.3s ease' }}>
                {index >= 4
                  ? <Collapse in={showMore}>
                    <ResultCard item={item} homeView={true} />
                  </Collapse>
                  : <ResultCard item={item} homeView={true} />
                }
              </Grid>
            ))
          }
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <IconButton onClick={() => setShowMore(!showMore)}
            color='primary' sx={{ width: 50, height: 50 }}
          >
            {showMore ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
      </Container>
      {/* User types */}
      <Box
        sx={{ pb: 12 }}
        style={{ background: 'linear-gradient(135deg, #eaf7dc 0%, #ffffb0 100%)' }}
      >
        <Container maxWidth='lg'>
          <Typography
            variant='h4'
            color='primary.light'
            textAlign='center'
            sx={{ mt: 10, mb: 10, fontWeight: 'bold' }}
          >
            診所護理師討論、學習及照顧的小幫手！
          </Typography>
          <Grid container spacing={2} justifyContent='center'>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Card variant='outlined' sx={{ borderRadius: 10, borderColor: 'primary', borderWidth: 4, bgcolor: 'transparent' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                    <PersonalInjuryOutlinedIcon sx={{ fontSize: 100, color: 'primary.dark' }} />
                  </Box>
                  <Typography variant='h5' color='primary.dark' sx={{ fontWeight: 'bold', mb: 1 }} textAlign='center'>病人</Typography>
                  <Typography variant='body1' color='primary.dark' sx={{ fontSize: 20 }} textAlign='center'>居家醫療照護指引</Typography>
                  <Typography variant='body1' color='primary.dark' sx={{ fontSize: 20 }} textAlign='center'>疾病自我管理知識</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              {/* <Card sx={{ borderRadius: 10, bgcolor: 'gold' }}> */}
              <Card variant='outlined' sx={{ borderRadius: 10, borderColor: yellow_color, borderWidth: 4, bgcolor: 'transparent' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                    <VaccinesIcon sx={{ fontSize: 100, color: yellow_color }} />
                  </Box>
                  <Typography variant='h5' color='secondary' sx={{ fontWeight: 'bold', mb: 1 }} textAlign='center'>護理人員</Typography>
                  <Typography variant='body1' color='secondary' sx={{ fontSize: 20 }} textAlign='center'>衛教單張與SOP</Typography>
                  <Typography variant='body1' color='secondary' sx={{ fontSize: 20 }} textAlign='center'>衛教技巧以及儀器操作</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Card variant='outlined' sx={{ borderRadius: 10, borderColor: red_color, borderWidth: 4, bgcolor: 'transparent' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                    <MedicalInformationIcon sx={{ fontSize: 100, color: red_color }} />
                  </Box>
                  <Typography variant='h5' color='error' sx={{ fontWeight: 'bold', mb: 1 }} textAlign='center'>醫生</Typography>
                  <Typography variant='body1' color='error' sx={{ fontSize: 20 }} textAlign='center'>匿名討論</Typography>
                  <Typography variant='body1' color='error' sx={{ fontSize: 20 }} textAlign='center'>沒有壓力</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* 友情連結 */}
      <Box sx={{ pb: 12 }}>
        <Container maxWidth='lg'>
          <Typography
            variant='h4'
            color='primary'
            textAlign='center'
            sx={{ mt: 10, mb: 10, fontWeight: 'bold' }}
          >
            友善連結
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }} sx={{
              display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
              mb: { xs: 6, md: 0 }
            }}>
              <Link to={idf_link} component={RouterLink} target='_blank' style={{ textDecoration: 'none' }}>
                <Box
                  component='img'
                  src='/social/idf_logo.svg'
                  sx={{
                    height: '80px',
                    mb: 2,
                  }}
                />
                <Typography variant='h5' color='primary' textAlign='center'>網路商場</Typography>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
              <Link to={yt_link} component={RouterLink} target='_blank' style={{ textDecoration: 'none' }}>
                <Box
                  component='img'
                  src='/social/sososo_logo.svg'
                  sx={{
                    height: { xs: '60px', sm: '80px' },
                    mb: 2,
                  }}
                />
                <Typography variant='h5' color='primary' textAlign='center'>Youtube頻道</Typography>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* 聯絡 */}
      <Box sx={{ pb: 8 }} style={{ background: 'linear-gradient(160deg, #eaf7dc 0%, #f9f2ff 100%)' }}>
        <Container maxWidth='lg'>
          <Grid container justifyContent='center' alignItems='center' spacing={8} sx={{ mt: 10 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Stack sx={{ alignItems: 'center' }} spacing={6}>
                <Typography
                  variant='h4'
                  color='primary.dark'
                  textAlign='center'
                  sx={{ mb: 6, fontWeight: 'bold' }}
                >
                  聯絡、加入我們！
                </Typography>
                {become_member_btn}
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Link to={line_link} component={RouterLink} target='_blank' style={{ textDecoration: 'none' }}>
                <Box
                  component='img'
                  src='/social/line_qrcode.jpg'
                  sx={{
                    height: '250px',
                    mb: 2,
                  }}
                />
                <Typography variant='h6' color='primary' textAlign='center'>點擊加入Line!</Typography>
                <Typography variant='h6' color='primary' textAlign='center'>或電話搜尋 0972-931-931</Typography>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Divider />
    </>
  );
}

export default Home;